export default function ParentsWeekendScreenshot(){
    return (
        <>
            <img src='ParentsWeekendScreenshot.jpg' style={{maxWidth:'100%'}} />
            

        </>
    )
}